module.exports = __webpack_public_path__ + "static/img-historie-afcbfd5790e22d2473941768aa1283f4.jpg";